import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { type FC, useState } from "react";

import { GetUpdatesContent } from "~/feature/getUpdates/components/GetUpdatesContent";
import { GetUpdatesDialog } from "~/feature/getUpdates/components/GetUpdatesDialog";
import { markUpdatesSeen } from "~/feature/getUpdates/utils/getUpdatesStorage";

import * as Styled from "./GetUpdatesAppBarButton.styles";

export const GetUpdatesAppBarButton: FC = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
    markUpdatesSeen();
  };

  return (
    <>
      <Styled.TriggerButton
        variant="contained"
        size="small"
        aria-label="Get updates"
        startIcon={<NotificationsNoneOutlinedIcon />}
        onClick={handleOpen}
      >
        <Styled.Label>Get updates</Styled.Label>
      </Styled.TriggerButton>
      <GetUpdatesDialog open={open} onClose={handleClose}>
        <GetUpdatesContent onClose={handleClose} source="site_button" />
      </GetUpdatesDialog>
    </>
  );
};
